import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-purple-900/20 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand Section */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <div className="w-14 h-14 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/ce4d344d8477028dc98a5cc47eb4181f/bcc84ca85cd963cb50fc1fe5675eb2ae.jpeg" 
                  alt="TV Plus+ Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="text-3xl font-bold bg-gradient-to-r from-pink-500 via-purple-500 to-cyan-500 bg-clip-text text-transparent">
                TV Plus+
              </span>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Tu plataforma definitiva para descubrir películas, series, anime, novelas y libros. Reseñas, recomendaciones personalizadas y transmisiones en vivo.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-white/30 text-white hover:border-pink-500 hover:text-pink-500 transition-all duration-300 cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-white/30 text-white hover:border-cyan-500 hover:text-cyan-500 transition-all duration-300 cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-white/30 text-white hover:border-purple-500 hover:text-purple-500 transition-all duration-300 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-white/30 text-white hover:border-red-500 hover:text-red-500 transition-all duration-300 cursor-pointer"
                aria-label="YouTube"
              >
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wider">Enlaces Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-pink-500 transition-colors text-sm">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/catalogo" className="text-gray-300 hover:text-pink-500 transition-colors text-sm">
                  Catálogo Completo
                </Link>
              </li>
              <li>
                <Link to="/en-vivo" className="text-gray-300 hover:text-pink-500 transition-colors text-sm">
                  Transmisión en Vivo
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-gray-300 hover:text-pink-500 transition-colors text-sm">
                  Contacto y Publicidad
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wider">Contacto</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-mail-line text-pink-500"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-400 uppercase tracking-wider mb-1">Email</p>
                  <a href="mailto:contact17tvplus@gmail.com" className="text-sm text-gray-300 hover:text-pink-500 transition-colors">
                    contact17tvplus@gmail.com
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-telegram-line text-cyan-500"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-400 uppercase tracking-wider mb-1">Telegram</p>
                  <a href="https://t.me/TV_Plus17" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-300 hover:text-cyan-500 transition-colors">
                    @TV_Plus17
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-twitch-line text-purple-500"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-400 uppercase tracking-wider mb-1">Twitch</p>
                  <a href="https://twitch.tv/tv_plus17" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-300 hover:text-purple-500 transition-colors">
                    twitch.tv/tv_plus17
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-sm text-gray-400">
            © {currentYear} TV Plus+. Todos los derechos reservados.
          </p>
          <div className="flex items-center space-x-6">
            <a href="/privacidad" className="text-sm text-gray-400 hover:text-pink-500 transition-colors">
              Privacidad
            </a>
            <a href="/terminos" className="text-sm text-gray-400 hover:text-pink-500 transition-colors">
              Términos
            </a>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-pink-500 transition-colors">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
